/**
 * Unified client-side conversion tracking for Meta Pixel + GA4.
 * Both trackers are optional/best-effort - if a script is blocked (ad
 * blockers, consent tools) or the env var isn't set, calls silently no-op
 * so tracking never breaks the actual donation flow.
 *
 * Only ever pass: value, currency, donation_type, case_id, transaction_id.
 * NEVER pass donor name/email/PAN or animal medical details as event params.
 */

function hasFbq() {
  return typeof window !== "undefined" && typeof window.fbq === "function";
}

function hasGtag() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

function getCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

/** Meta Pixel's own first-party cookies - forwarded to the backend at checkout
 * so the server-side Conversions API call can include them for better match
 * quality (never anything else PII-like is read from cookies here). */
export function getFbCookies() {
  return { fbp: getCookie("_fbp"), fbc: getCookie("_fbc") };
}

export function trackPageView() {
  if (hasFbq()) window.fbq("track", "PageView");
  if (hasGtag()) window.gtag("event", "page_view", { page_title: document.title, page_location: window.location.href });
}

/** Fired the moment a donor's checkout is about to open (Razorpay modal about to launch). */
export function trackInitiateCheckout({ value, donationType, caseId, contentName, contentCategory, contentIds }) {
  const params = {
    value: Number(value) || 0,
    currency: "INR",
    donation_type: donationType,
    ...(caseId ? { case_id: caseId } : {}),
    ...(contentName ? { content_name: contentName } : {}),
    ...(contentCategory ? { content_category: contentCategory } : {}),
    ...(contentIds ? { content_ids: contentIds } : {}),
  };
  if (hasFbq()) window.fbq("track", "InitiateCheckout", params);
  if (hasGtag()) window.gtag("event", "begin_checkout", params);
}

/** Fired only after the backend has verified a captured payment. */
export function trackPurchase({ value, donationType, caseId, transactionId, contentName, contentCategory, contentIds }) {
  const baseParams = {
    value: Number(value) || 0,
    currency: "INR",
    donation_type: donationType,
    ...(caseId ? { case_id: caseId } : {}),
    ...(contentName ? { content_name: contentName } : {}),
    ...(contentCategory ? { content_category: contentCategory } : {}),
    ...(contentIds ? { content_ids: contentIds } : {}),
  };
  if (hasFbq()) window.fbq("track", "Purchase", baseParams, transactionId ? { eventID: transactionId } : undefined);
  if (hasGtag()) window.gtag("event", "purchase", { ...baseParams, transaction_id: transactionId });
}
